import WithSidebar from 'Layout/WithSidebar';
import Banner from 'components/Banner';
import bannerImage from 'images/detailed-trial-results-banner.jpg';
import ProductSidebar from 'components/ProductSidebar';
import { data } from 'components/ProductSidebar/mockData';
import PDFBox from 'components/PDFBox';
import { files } from './mockData';

const DetailedTrialResults = () => {
    const slicedData = [...data].slice(5);

    return (
        <>
            <Banner title="Spring wheat" image={bannerImage} buttonText="View results" />
            <section className="container">
                <WithSidebar
                    containerType="type-1"
                    mobileReversed
                    Sidebar={<ProductSidebar title="Trial results for other crops" data={slicedData} />}
                >
                    <PDFBox data={files} />
                </WithSidebar>
            </section>
        </>
    );
};

export default DetailedTrialResults;
